export default __webpack_public_path__ + "static/media/3105.68775442.jpg";